<template>
  <section id="wizard-step-2" class="form-content">
    <sc-form :form="formContent" :has-style="false" @submit="(val) => $emit('onNextStep', val)">
      <template slot="fields" slot-scope="{ fields }">
        <section class="upload-form">
          <sc-field id="template-step-4" class="upload-form__step" prop="rowNumber">
            <template slot="label">
              <span class="upload-form__step__label">
                <sc-tag size="is-medium" rounded>4</sc-tag>
                Linha do cabeçalho
                <p class="additional-label">Digite o número da linha onde está localizado o cabeçalho da planilha da fatura</p>
              </span>
            </template>
            <sc-input
              size="is-medium" style="width: 66px"
              type="number" min="1"
              v-model="fields.rowNumber" id="rowNumber"
              @keydown.native="$event.preventDefault()"/>
          </sc-field>
          <div class="upload-form__step">
            <new-billing-template-image-helper />
          </div>
        </section>
      </template>
      <template slot="actions" slot-scope="{ isValid }">
        <section class="continue-buttom">
          <button class="button" type="button" @click="$emit('onPrevStep');">Voltar</button>
          <button class="button is-primary" type="submit">Continuar</button>
        </section>
      </template>
    </sc-form>
  </section>
</template>

<script>
import { ScField, ScTag, ScInput, ScForm, ScCard } from '@intelipost-js/secure-components';
import NewBillingTemplateImageHelper from './NewBillingTemplateImageHelper.vue';

export default {
  name: 'billingTemplateStep2',
  data() {
    return {
      formContent: { rowNumber: 1 },
    };
  },
  components: {
    ScField, ScTag, ScInput, ScForm, ScCard, NewBillingTemplateImageHelper,
  },
};
</script>

<style lang="scss">
#rowNumber {
  max-width: 60px;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateStep2.vue?00bb818a